import { UnknownAction } from '@reduxjs/toolkit';
import { FETCHING_DATASET_FAILED, FETCHING_DATASET_REQUEST, FETCHING_DATASET_SUCCEDDED } from '../actions/actionTypes';
import { Dataset, DatasetResource, FetchDatasetResponse } from '../../types/dataseek';

interface DatasetState {
  loading: boolean;
  item: DatasetResource | null;
  error: any;
}

const initialState: DatasetState = {
  loading: false,
  item: null,
  error: null
};

export function datasetReducer(state: DatasetState = initialState, action: UnknownAction): DatasetState {
  switch (action.type) {
    case FETCHING_DATASET_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }

    case FETCHING_DATASET_SUCCEDDED: {
      const response = action.payload as FetchDatasetResponse;
      return {
        ...state,
        loading: false,
        item: response.response,
        error: null
      }
    }

    case FETCHING_DATASET_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }

    default:
      return state
  }
}